import { Box, Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Step, StepContent, StepLabel, Stepper } from "@mui/material";
import DialogAppBar from "../../../../../components/DialogAppBar";
import useMobileScreen from "../../../../../lib/useMobileScreen";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import AtualizacaoCadastral from "./AtualizacaoCadastral";
import DadosSolicitacao from "./DadosSolicitacao";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { ISolicitarAnaliseCreditoInput } from "../../../../../types/mutations/solicitar-analise-credito";
import { enqueueSnackbar } from "notistack";
import EnviarAnexos from "./EnviarAnexos";
import { TModalContent, defaultValuesForm } from "..";
import DisplayListagemRascunhos from "../../../../../components/DisplayListagemRascunhos";
import useMutateRascunho from "../../../../../lib/useMutateRascunho";
import { tratativaDownloadForm, tratativaEnvioForm, tratativaSalvarForm } from "./tratativaForm";
import { IRascunhoArquivo } from "../../../../../types/api/financeiro/pesquisar-rascunhos";
import DisplayDadosClienteFormulario from "../../MIAnaliseDeCredito/DisplayDadosClienteFormulario";
import DadosPropriedade from "./DadosPropriedade";

export default function FormSolicitacao({
    handleClose,
    handleNext,
    handleBack,
    handleChangeProcesso,
    onCreate,
    activeStep,
    onCleanForm
}: FormSolicitacaoProps) {

    const telaMobile = useMobileScreen()
    const { handleSaveRascunho, isLoadingSalvarRascunho } = useMutateRascunho("SolicitarAnaliseCredito")

    //formulario
    const { handleSubmit, getValues, reset, formState: { errors } } = useFormContext()

    const defaultValueCliente = getValues("cliente")
    //

    //queries e mutations
    const { mutate: criarSolicitacaoCredito, isLoading: isLoadingSolictCredito } = useMutation({
        mutationKey: 'solicitar-analise-credito',
        mutationFn: (inputs: ISolicitarAnaliseCreditoInput) => axiosClient.post("/financeiro/analise-credito/solicitar-analise-credito", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: ({ response }) => {
            enqueueSnackbar('Erro ao cadastrar solcitação de análise de crédito!', { variant: 'error' });
        },
        onSuccess: ({ data }) => {
            if (data.codigo && data.message) {
                handleChangeProcesso(data.codigo)
                enqueueSnackbar(data.message, { variant: 'success' });
                handleClose()
            } else {
                handleChangeProcesso(data)
                onCreate()
                enqueueSnackbar(`Cadastro da solcitação #${data} realizada com sucesso!`, { variant: 'success' });
                handleClose()
            }
        }
    })
    //

    //funções manipuladoras
    const handleSendForm = useCallback(async () => {
        const { cliente, attCadastral, dadosProp, dadosSolicitacao, enviarAnexos } = getValues()

        const params = tratativaEnvioForm(
            cliente,
            attCadastral,
            dadosProp,
            dadosSolicitacao,
            enviarAnexos
        )

        await criarSolicitacaoCredito(params)
    }, [getValues, criarSolicitacaoCredito])

    const handleSalvarRascunho = () => {
        const {
            cliente,
            attCadastral,
            dadosProp,
            dadosSolicitacao,
            enviarAnexos
        } = getValues()

        const { params, arquivos }: any = tratativaSalvarForm(
            cliente,
            attCadastral,
            dadosProp,
            dadosSolicitacao,
            enviarAnexos
        )

        handleSaveRascunho(params, arquivos)
        handleClose()
    }

    const handleDownloadForm = (data: string, arquivos: IRascunhoArquivo[]) => {
        const paramsForm = tratativaDownloadForm(data, arquivos)
        reset(paramsForm);
    }
    //

    return (
        <>
            {
                telaMobile &&
                <DialogAppBar
                    {...{ handleClose }}
                    title="Solicitar análise de crédito"
                />
            }

            <DialogTitle id="draggable-dialog-title">
                Solicitar análise de crédito
            </DialogTitle>

            <DialogContent sx={{ mt: { xs: 2, md: 0 } }}>
                <DisplayDadosClienteFormulario tipoDado="context" />

                <DisplayListagemRascunhos
                    componente="SolicitarAnaliseCredito"
                    onDownloadForm={handleDownloadForm}
                    queryFields={{
                        chave: "cliente->codigo_publico",
                        tipo_valor: "string",
                        valor: defaultValueCliente.codigo_publico
                    }}
                />

                <Stepper activeStep={activeStep} orientation="vertical" sx={{ mt: 2 }}>
                    {
                        steps.map((step, index) => {
                            const primeiroStep = index === 0
                            const ultimoStep = index === steps.length - 1

                            return (
                                <Step key={step.label}>
                                    <StepLabel>
                                        {step.label}
                                    </StepLabel>
                                    <StepContent>
                                        {step.content}
                                        <Box sx={{ mb: 2 }}>
                                            <div>
                                                <Button
                                                    disabled={isLoadingSolictCredito}
                                                    variant="contained"
                                                    onClick={handleSubmit(ultimoStep ? handleSendForm : handleNext)}
                                                    sx={{ mt: 1, mr: 1 }}
                                                >
                                                    {
                                                        isLoadingSolictCredito &&
                                                        <CircularProgress size={20} sx={{ marginRight: 1 }} />
                                                    }
                                                    {ultimoStep ? 'Finalizar' : 'Avançar'}
                                                </Button>

                                                <Button
                                                    disabled={isLoadingSalvarRascunho}
                                                    variant="outlined"
                                                    onClick={handleSalvarRascunho}
                                                    sx={{ mt: 1, mr: 1 }}
                                                >
                                                    {
                                                        isLoadingSalvarRascunho &&
                                                        <CircularProgress size={20} sx={{ marginRight: 1 }} />
                                                    }
                                                    Salvar rascunho
                                                </Button>

                                                {
                                                    !primeiroStep &&
                                                    <Button
                                                        disabled={isLoadingSolictCredito}
                                                        onClick={handleBack}
                                                        sx={{ mt: 1, mr: 1 }}
                                                    >
                                                        voltar
                                                    </Button>
                                                }
                                            </div>
                                        </Box>
                                    </StepContent>
                                </Step>
                            )
                        })
                    }
                </Stepper>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="text"
                    onClick={() => {
                        reset({ ...defaultValuesForm })
                        onCleanForm()
                    }}
                >
                    Limpar
                </Button>
            </DialogActions>
        </>
    )
}

const steps = [
    {
        label: 'Atualização cadastral',
        content: <AtualizacaoCadastral />,
    },
    {
        label: 'Dados Propriedade',
        content: <DadosPropriedade />,
    },
    {
        label: 'Dados da solicitação',
        content: <DadosSolicitacao />,
    },
    {
        label: 'Anexos',
        content: <EnviarAnexos />
    }
];

interface FormSolicitacaoProps {
    modalContent: TModalContent,
    handleChangeProcesso: (item: string) => void,
    onBack: () => void,
    onCreate: () => void
    onFail: () => void,
    handleClose: () => void,
    handleNext: () => void
    handleBack: () => void,
    activeStep: number,
    onCleanForm: () => void
}

type TPropToCheck = keyof ISolicitarAnaliseCreditoInput